import { z } from "zod";

export const PUBLIC_CONTACT_TOPICS = [
  "general",
  "clinic",
  "beta",
  "support",
  "deletion",
] as const;

export const publicContactSchema = z
  .object({
    name: z.string().trim().min(2).max(120),
    email: z.string().trim().email(),
    topic: z.enum(PUBLIC_CONTACT_TOPICS),
    message: z.string().trim().min(10).max(2000),
    acceptPrivacy: z.literal(true),
  })
  .strict();
